export default __webpack_public_path__ + "static/media/delete.df41d0ff.svg";